/**
 * SC-452: hand a session the server says has ended over to the app's
 * invalid-session handling (`parseCloud.handleInvalidSession`): a sign-out
 * outside a call, nothing inside one, debounced so a burst of failures signs
 * out once.
 *
 * With `parseFailure`, only a Parse invalid-session error (209/206) is handed
 * over; without it, the caller has already decided the session ended.
 *
 * Started, never awaited: a sign-out that never answers must not hold up the
 * caller, whether that is the next background save or a picker's busy state.
 * The promise settles once the hand-over has finished. Callers drop it; tests
 * wait on it to say for certain that a failure was not handed over.
 *
 * Its own module so it can stay lazy. parseCloud initialises the Parse SDK and
 * loads the auth service on import, which the background modules, and the many
 * tests that import them with a partial `parse` mock, otherwise do without.
 */
export function reportEndedSession(parseFailure?: unknown): Promise<void> {
  return (async () => {
    try {
      const { handleInvalidSession, isInvalidSessionError } = await import('./parseCloud')
      if (parseFailure !== undefined && !isInvalidSessionError(parseFailure)) return
      await handleInvalidSession()
    } catch (error) {
      console.warn('[SC-452] Could not hand the ended session over:', error)
    }
  })()
}
